import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=ef801a04&scoped=true&"
import script from "./InfoTab.vue?vue&type=script&lang=js&"
export * from "./InfoTab.vue?vue&type=script&lang=js&"
import style0 from "./InfoTab.vue?vue&type=style&index=0&id=ef801a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef801a04",
  null
  
)

export default component.exports